
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_1ev1z_99",
  "trigger": "awsui_trigger_14cnr_1ev1z_136",
  "dropdown": "awsui_dropdown_14cnr_1ev1z_139",
  "nowrap": "awsui_nowrap_14cnr_1ev1z_150",
  "open": "awsui_open_14cnr_1ev1z_153"
};
  